import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

// Fetch a file through the API (so an expired sign-in renews itself) and hand it to the browser.
export async function download(path, params) {
  try {
    const res = await api.get(path, { params, responseType: "blob" });
    const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "download.xlsx";
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  } catch (e) {
    let detail = e.response?.data?.detail;
    if (e.response?.data instanceof Blob) {
      try { detail = JSON.parse(await e.response.data.text()).detail; } catch { /* not JSON */ }
    }
    toast.error(formatApiErrorDetail(detail));
  }
}
